module.exports = __webpack_public_path__ + "img/quick_release_03.708f6665.png";